import React, { Component } from 'react';
import './FaceRotrationArrow.css';
import { isSafari, isMobileSafari } from "react-device-detect";

class FaceRotrationArrow extends Component {
    constructor(props) {
        super(props);
        var beginRz = 200;
        var deltaRz = 30;

        this.state = { speed: 2000, rz: beginRz, deltaRz: deltaRz, beginRz: beginRz, transitionTime: 2000 };

    }
    componentDidMount() {
        setInterval(() => {
            this.setState({ transitionTime: this.state.speed });
            this.setState({ rz: this.state.beginRz + this.state.deltaRz });

            setTimeout(() => {
                this.setState({ transitionTime: 0 });
                this.setState({ rz: this.state.beginRz });
            }, this.state.speed - 100)


        }, this.state.speed);

    }

    getFaceRotrationArrowPosition() {
        // if (isSafari || isMobileSafari) {
        //     console.log("Safari detected")
        // };
        if (window.innerHeight > window.innerWidth && (isSafari || isMobileSafari))
        {
            console.log("portrait")
            return "200px"
        }
        else
        {
            console.log("landscape")
        }
    }

    render() {
        return (
            <div className='FaceRotrationArrow'
                style={{ transform: this.props.directionRight ? "scaleX(-1)" : "scaleX(1)", top: this.getFaceRotrationArrowPosition() }}
            >
                <div className="FaceRotrationArrow" style={{
                    transform: `rotateX(65deg) rotateZ(${this.state.rz}deg)`,
                    transition: `${this.state.transitionTime}ms linear transform`

                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="#fffffff0" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M 8 3 a 5 5 0 0 0 -5 5 a 0.5 0.5 0 0 1 -1 -0 A 6 6 0 0 1 8 2 v 1 z" />
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                    </svg>
                </div>

            </div>

        );
    }
}

export default FaceRotrationArrow;